export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="bg-gradient-to-br from-background-100 to-background-50 border border-background-200/60 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
            你手上有精彩的吃瓜线索？想要投稿爆料或者与我们取得联系？
            51黑料吃瓜网欢迎每一位吃瓜群众的来信，你的线索可能成为下一个爆款内容。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-8">
            <div className="bg-background-50 border border-background-200/50 rounded-xl p-4">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-accent-600"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">投稿邮箱</p>
              <p className="text-sm font-medium text-foreground-800">tips@51heiliaochigua.com</p>
            </div>
            <div className="bg-background-50 border border-background-200/50 rounded-xl p-4">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-wechat-line text-lg text-primary-600"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">官方微信</p>
              <p className="text-sm font-medium text-foreground-800">51黑料吃瓜网</p>
            </div>
            <div className="bg-background-50 border border-background-200/50 rounded-xl p-4">
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-secondary-100 flex items-center justify-center">
                <i className="ri-message-3-line text-lg text-secondary-600"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">工作时间</p>
              <p className="text-sm font-medium text-foreground-800">7×24小时在线</p>
            </div>
          </div>

          <a
            href="#hero"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-up-line text-lg"></i>
            返回顶部
          </a>
        </div>
      </div>
    </section>
  );
}